import axios from '@/plugins/api.request'

/**
 * 用户登录
 * @param {*} data
 */
export const login = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.User.Login',
    data
  })
}

/**
 * 用户登录
 * @param {*} data
 */
export const register = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.User.Register',
    data
  })
}

/**
 * 获取用户信息
 * @param {*} data 
 */
export const getProfile = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.User.Profile',
    data
  })
}

/**
 * 更新用户信息
 * @param {*} data 
 */
export const updateProfile = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.User.UpdateProfile',
    data
  })
}

/**
 * 搜索用户
 * @param {*} data
 */
export const searchUser = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.User.searchUser',
    data
  })
}

/**
 * 修改密码
 * @param {*} data
 */
export const resetPassword = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.User.ResetPassword',
    data
  })
}